// Swipe / Browse pill toggle. Lives in the AppHeader right slot when the
// Discover tab is active; controls how that screen presents the persona pool.
// Visual conventions mirror ModeToggle's old shape so the affordance feels
// familiar even though the modes themselves are gone.

import { C } from '@/styles/tokens';

export type DiscoverView = 'swipe' | 'browse';

interface DiscoverViewToggleProps {
  view: DiscoverView;
  onChange: (next: DiscoverView) => void;
}

export function DiscoverViewToggle({ view, onChange }: DiscoverViewToggleProps) {
  return (
    <div
      className="flex p-1 rounded-full"
      style={{ background: 'rgba(26,22,20,0.06)' }}
      role="tablist"
      aria-label="Discover view"
    >
      <ToggleButton selected={view === 'swipe'} onClick={() => onChange('swipe')} label="Swipe" hz="滑动" />
      <ToggleButton selected={view === 'browse'} onClick={() => onChange('browse')} label="Browse" hz="浏览" />
    </div>
  );
}

function ToggleButton({
  selected,
  onClick,
  label,
  hz,
}: {
  selected: boolean;
  onClick: () => void;
  label: string;
  hz: string;
}) {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={selected}
      onClick={onClick}
      className="px-3 py-1.5 rounded-full ff-body text-[10px] uppercase tracking-[0.2em] font-bold transition-all inline-flex items-center gap-1.5"
      style={{
        background: selected ? C.ink : 'transparent',
        color: selected ? 'white' : C.inkLight,
      }}
    >
      {label}
      <span className="ff-zh-serif text-[11px] tracking-normal opacity-80">{hz}</span>
    </button>
  );
}
